import { render, staticRenderFns } from "./PromoUpgrade.vue?vue&type=template&id=2dbb02c0&"
import script from "./PromoUpgrade.vue?vue&type=script&lang=js&"
export * from "./PromoUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbb02c0')) {
      api.createRecord('2dbb02c0', component.options)
    } else {
      api.reload('2dbb02c0', component.options)
    }
    module.hot.accept("./PromoUpgrade.vue?vue&type=template&id=2dbb02c0&", function () {
      api.rerender('2dbb02c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/redeem/PromoUpgrade.vue"
export default component.exports